import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-custom-card',
  styleUrls: ['dda-custom-card.css'],
  shadow: false,
})
export class DdaCustomCard {
  @Prop() card_header_text: string;
  @Prop() card_header_icon: string;
  @Prop() card_header_icon_id: string;

  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 

  @Prop() clickHandler?: (event: MouseEvent) => void;
  
  handleButtonClick = (event: CustomEvent<{ event: MouseEvent; id: string; value?: string; name?: string; }>) => {
    if (this.clickHandler) {
      this.clickHandler(event.detail.event);
    }
    console.log('Button clicked inside parent:', event.detail);
  }
  noop = () => {};

  render() {
    const cardClass = [
      'dda-card',
      this.custom_class ? `${this.custom_class}` : "",
      this.component_mode,
    ].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={cardClass}>
          
          {this.card_header_text && (
            <div class="dda-card-header" role="heading" aria-level="2">
              <h6 class="h6 Regular" aria-label="Card header">{this.card_header_text}</h6>

              {this.card_header_icon && (
                <dda-button
                  button_name="Card options menu"
                  button_color="onsurface-link"
                  icon_button_shape="circle"
                  start_icon={this.card_header_icon}
                  button_id={this.card_header_icon_id}
                  aria_label="Card options menu"
                  size="md"
                  onButtonClick={this.handleButtonClick} 
                  // onpressKey={() => console.log()} 
                  custom_class="dda-header-dots"
                  component_mode=""
                ></dda-button>
              )}
            </div>
          )}
          <div class="dda-card-body">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
